import { createActionGroup, emptyProps, props } from "@ngrx/store";

import { LocationType } from "src/app/global.constants";

import { ActionSource } from "../../../state/action-sources";

export const JobManuallyAddLocationActions = createActionGroup({
  source: ActionSource.JOB_MANUALLY_ADD_LOCATION,
  events: {
    'Street Number Input Changed': props<{
      streetNumber: string,
    }>(),
    'Street Name Input Changed': props<{
      streetName: string,
    }>(),
    'Area Code Input Changed': props<{
      areaCode: string,
    }>(),
    'City Input Changed': props<{
      city: string,
    }>(),
    'Country Selected': props<{
      country: string,
    }>(),
    'Jurisdiction Selected': props<{
      jurisdiction: string,
    }>(),
    'Add Location Button Clicked': props<{
      locationType: LocationType,
      streetNumber: string,
      streetName: string,
      areaCode: string,
      city: string,
      country: string,
      jurisdiction: string,
    }>(),
    'Cancel Button Clicked': emptyProps(),
    'Close Dialog Button Clicked': emptyProps(),
  },
})
